import { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";

const CountUp = ({ target = 20, duration = 1500 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          animateCount();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const animateCount = () => {
    const start = performance.now();

    const update = (currentTime) => {
      const progress = Math.min((currentTime - start) / duration, 1);
      setCount(Math.floor(progress * target));

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  };

  return (
    <span ref={ref} className={styles.countUp}>
      {count}
    </span>
  );
};

export default CountUp;
